<script setup>
import ActionModal from '@/components/modals/ActionModal.vue'

defineProps({
	groupName: {
		type: String,
		default: '',
	},
})

const isVisible = defineModel('isVisible', { type: Boolean, default: false })
const emit = defineEmits(['confirm', 'cancel'])
</script>

<template>
	<ActionModal
		v-model:isVisible="isVisible"
		title="Delete group"
		confirm-text="Delete"
		cancel-text="Cancel"
		:on-submit="() => emit('confirm')"
		:on-cancel="() => emit('cancel')"
	>
		Are you sure you want to delete group "<strong>{{ groupName }}</strong>"?
	</ActionModal>
</template>
